import { render, staticRenderFns } from "./chip.vue?vue&type=template&id=439e3508&scoped=true&lang=pug&"
import script from "./chip.vue?vue&type=script&lang=js&"
export * from "./chip.vue?vue&type=script&lang=js&"
import style0 from "./chip.vue?vue&type=style&index=0&id=439e3508&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439e3508",
  null
  
)

export default component.exports